import { toast } from "react-toastify";

const blockPasswordClipboard = (event) => {
  event.preventDefault();
  toast.warn("Copying and pasting passwords is disabled.", {
    toastId: "password-clipboard-disabled",
  });
};

export const passwordClipboardProps = {
  onCopy: blockPasswordClipboard,
  onCut: blockPasswordClipboard,
  onPaste: blockPasswordClipboard,
  onDragStart: blockPasswordClipboard,
  onDrop: blockPasswordClipboard,
};
